module.exports = __webpack_public_path__ + "static/media/s2.e7e372e7.jpg";